export default __webpack_public_path__ + "static/media/b-6.af4c53d9.png";